import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ProductCategoryCreateComponent } from './product-category-create/product-category-create.component';
import { ProductCategoryDetailsComponent } from './product-category-details/product-category-details.component';
import { ProductCategoryEditComponent } from './product-category-edit/product-category-edit.component';

const routes: Routes = [
  {
    path: 'Insurance/ProductCategories',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductCategory,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: ProductCategoryDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductCategory,
          breadcrumb: { label: ' ', alias: 'productCategoryDetails' },
        },
      },
      {
        path: 'Create',
        component: ProductCategoryCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductCategory,
          breadcrumb: { label: ' ', alias: 'productCategoryCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: ProductCategoryEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.ProductCategory,
          breadcrumb: { label: ' ', alias: 'productCategoryEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductCategoryRoutingModule {}
